<div *ngIf="!loading">
  <div class="row">
    <div class="col-md-4">
      <label for="companyTp">{{genericVisuals.cmpType}}</label>
      <select class="form-control" [(ngModel)]="selectedCompanyType" (change)="refreshLists()" [disabled]="fourEyes">
        <option *ngFor="let position of companyTypeList" [ngValue]="position.id">
          {{position.text}}
        </option>
      </select>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-5">
      <div *ngIf="!viewRole && !fourEyes">
        <i
          class="mdi md-16 mdi-checkbox-marked"
          *ngIf="selectedRemaingList.length == 0 && getRemaingList.length != 0"
          (click)="selectAllRemaining()"
          >{{genericVisuals.selectAll}}</i
        >
        <i
          class="mdi md-16 mdi-close text-danger"
          *ngIf="selectedRemaingList.length > 0"
          (click)="selectAllRemaining()"
          >{{genericVisuals.deselectAll}}</i
        >
      </div>
      <div class="list-group">
        <div
          *ngFor="let pk of getRemaingList;"
          [ngClass]="{'selectedItem-onBoard-Docs': selectedRemaingList.includes(pk.id)}"
          (click)="!fourEyes && !viewRole ? assign(pk.id) : null"
          [style.pointerEvents]="fourEyes ? 'none' : 'auto'"
          [style.opacity]="fourEyes ? 0.8 : 1"
          style="margin-bottom: 5px;cursor:pointer;"
          class="first list-group-item"
        >
          <i
            class="mdi md-16 mdi-checkbox-marked"
            style="position: absolute;right:4px;"
            [ngClass]="{'text-success':selectedRemaingList.includes(pk.id)}"
          ></i>
          {{ pk.id | filterList:docList }}
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div *ngIf="!viewRole">
        <div class="text-center" 
        [ngClass]="{'arrow-wrapper':fourEyes}"
        (click)="!fourEyes && assignRequest()" 
        *ngIf="(!viewRole) && (!fourEyes || differences?.action?.rightValue == 'link')"
        [style.pointerEvents]="fourEyes ? 'none' : 'auto'">
          <i class="mdi md-xxl mdi-chevron-right"></i>
        </div>
        <div class="text-center" 
        [ngClass]="{'arrow-wrapper':fourEyes}"
        (click)="!fourEyes && unAssignRequest()"
        *ngIf="(!viewRole) && (!fourEyes || differences?.action?.rightValue == 'unlink')"
        [style.pointerEvents]="fourEyes ? 'none' : 'auto'">
          <i class="mdi md-xxl mdi-chevron-left"></i>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div *ngIf="!viewRole && !fourEyes">
        <i
          class="mdi md-16 mdi-checkbox-marked"
          *ngIf="selectedAssignedList.length == 0 && getAssignedList.length != 0"
          (click)="selectAllAssigned()"
          >{{genericVisuals.selectAll}}</i
        >
        <i
          class="mdi md-16 mdi-close text-danger"
          *ngIf="selectedAssignedList.length > 0"
          (click)="selectAllAssigned()"
          >{{genericVisuals.deselectAll}}</i
        >
      </div>
      <div class="list-group">
        <div
          *ngFor="let pk of getAssignedList;"
          [ngClass]="{'selectedItem-onBoard-Docs': selectedAssignedList.includes(pk.id)}"
          (click)="!fourEyes && !viewRole ? unAssign(pk.id) : null"
          [style.pointerEvents]="fourEyes ? 'none' : 'auto'"
          [style.opacity]="fourEyes ? 0.8 : 1"
          style="margin-bottom: 5px;cursor:pointer;"
          class="second list-group-item"
        >
          <i
            class="mdi md-16 mdi-checkbox-marked"
            style="position: absolute;right:4px;"
            [ngClass]="{'text-success':selectedAssignedList.includes(pk.id)}"
          ></i>
          {{ pk.id | filterList:docList }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card"  *ngIf="!loading && !fourEyes" >
  <div class="card-header">
    <strong>{{genericVisuals?.requestForApprovalGridTitle}}</strong>
    <a
        href="javascript:void(0);"
        role="button"
        class="pull-right"
        (click)="isCollapsed = !isCollapsed"
      >
        @if (isCollapsed) {
          <i class="fa fa-plus-circle"></i>
        } @else {
          <i class="fa fa-minus-circle"></i>
        }
      </a>
  </div>
  <div class="card-block p-0" [collapse]="isCollapsed">
    <requestsForApproval [selectorName]="tagName"></requestsForApproval>
  </div>
</div>

<div *ngIf="loading" class="dataLoader"></div>
